import { Link } from "react-router-dom";
import "./Hero.css";

/**
 * Home hero: positioning statement, primary Login CTA, and an abstract
 * dashboard mock (pure CSS/SVG — no image assets needed).
 */
const Hero = () => (
  <section className="hero">
    <div className="hero__inner">
      <div className="hero__copy">
        <p className="hero__eyebrow">
          Business management for service organizations
        </p>
        <h1 className="hero__title">
          Run your whole organization from one calm workspace.
        </h1>
        <p className="hero__subtitle">
          Carely IT brings your branches, staff, clients, appointments, follow-ups,
          messaging, and website tools together — so your team spends less time
          on admin and more time with clients.
        </p>
        <div className="hero__ctas">
          <Link to="/login" className="hero__cta hero__cta--primary">
            Login
          </Link>
          <Link to="/pricing" className="hero__cta hero__cta--secondary">
            View pricing
          </Link>
        </div>
        <p className="hero__note">
          Access is onboarding-based — no self-serve registration.
        </p>
      </div>

      <div className="hero__visual" aria-hidden="true">
        <div className="hero-board">
          <div className="hero-board__sidebar">
            <span className="hero-board__mark" />
            <span className="hero-board__navdot hero-board__navdot--active" />
            <span className="hero-board__navdot" />
            <span className="hero-board__navdot" />
            <span className="hero-board__navdot" />
          </div>
          <div className="hero-board__main">
            <div className="hero-board__topbar">
              <span className="hero-board__title-line" />
              <span className="hero-board__avatar" />
            </div>
            <div className="hero-board__stats">
              <div className="hero-stat">
                <span className="hero-stat__value">128</span>
                <span className="hero-stat__label">Appointments</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat__value">36</span>
                <span className="hero-stat__label">Follow-ups</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat__value">4</span>
                <span className="hero-stat__label">Branches</span>
              </div>
            </div>
            <div className="hero-board__chart">
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
              <span className="hero-board__bar" />
            </div>
            <div className="hero-board__rows">
              <span className="hero-board__row" />
              <span className="hero-board__row" />
            </div>
          </div>
        </div>

        <div className="hero-chip hero-chip--booking">
          <span className="hero-chip__dot" />
          Online booking received
        </div>
        <div className="hero-chip hero-chip--followup">
          <span className="hero-chip__dot" />
          Follow-up sent
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
